"use client"
import { Target, Users, Award, Globe, Factory, TrendingUp, Globe2, Shield } from "lucide-react"
import "./Company.css"

const Company = () => {
  const milestones = [
    { year: "1977", title: "Promoter's Father Mr.Mukesh Bhargava", description: "Started manufacturing of Auto Fluid Solutions" },
    { year: "2009", title: "Become India's 1st Manufacturer", description: "of Computer Cabinet Units" },
    { year: "2016", title: "Established", description: "Imperia Industries India Pvt. Ltd." },
    { year: "2022", title: "Catering International Market", description: "Started Catering International Market" },
  ]

  const stats = [
    { icon: <Factory />, number: "22", label: "Serving Indian States" },
    { icon: <Globe2 />, number: "10+", label: "Countries Served" },
    { icon: <TrendingUp />, number: "5,000+", label: "Custom Solutions" },
    { icon: <Shield />, number: "15+", label: "Years in Operation" },
  ]

  const values = [
    {
      icon: <Target size={24} />,
      title: "Precision Engineering",
      description: "Meticulous attention to detail in every solution we create",
    },
    {
      icon: <Users size={24} />,
      title: "Customer Partnership",
      description: "Building long-term relationships through exceptional service",
    },
    {
      icon: <Award size={24} />,
      title: "Quality Excellence",
      description: "Rigorous standards ensuring superior product performance",
    },
    {
      icon: <Globe size={24} />,
      title: "Sustainable Innovation",
      description: "Developing eco-conscious solutions for future mobility",
    },
  ]

  return (
    <div className="company-page-wrapper">
      {/* Hero Section */}
      <section className="company-hero-section">
        <div className="company-hero-container">
          <div className="company-hero-content">
            <span className="company-hero-subtitle">WHO WE ARE</span>
            <h1 className="company-hero-title">Pioneering Fluid Transmission Solutions</h1>
            <p className="company-hero-description">
              From past one decade, we've been at the forefront of developing advanced fluid management systems that
              power industries and enable technological progress.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="company-stats-section">
        <div className="company-stats-container">
          {stats.map((stat, index) => (
            <div key={index} className="company-stat-card">
              <div className="company-stat-icon">{stat.icon}</div>
              <div className="company-stat-content">
                <span className="company-stat-number-large">{stat.number}</span>
                <span className="company-stat-label-large">{stat.label}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* History Section - Redesigned */}
      <section className="company-history-section">
        <div className="company-section-header">
          <span className="company-section-subtitle">OUR JOURNEY</span>
          <h2 className="company-section-title">Building a Legacy of Innovation</h2>
        </div>

        <div className="company-timeline-container">
          <div className="company-timeline-progress">
            <div className="company-timeline-line"></div>
          </div>
          
          <div className="company-timeline-milestones">
            {milestones.map((milestone, index) => (
              <div key={index} className="company-milestone-card">
                <div className="milestone-year-bubble">
                  <span>{milestone.year}</span>
                </div>
                <div className="milestone-content">
                  <h3 className="milestone-title">{milestone.title}</h3>
                  <p className="milestone-description">{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="company-values-section">
        <div className="company-section-header">
          <span className="company-section-subtitle">OUR FOUNDATION</span>
          <h2 className="company-section-title">Core Principles That Guide Us</h2>
        </div>

        <div className="company-values-grid">
          {values.map((value, index) => (
            <div key={index} className="company-value-card">
              <div className="company-value-icon">{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="company-mission-vision-section">
        <div className="company-mission-card">
          <div className="company-card-content">
            <span className="company-card-label">OUR MISSION</span>
            <h3>Driving Technological Advancement</h3>
            <p>
              To develop cutting-edge fluid transmission systems that set industry benchmarks for performance,
              efficiency, and environmental sustainability, while delivering exceptional value to our global partners.
            </p>
          </div>
        </div>

        <div className="company-vision-card">
          <div className="company-card-content">
            <span className="company-card-label">OUR VISION</span>
            <h3>Shaping the Future of Mobility</h3>
            <p>
              To be the world's most trusted innovator in fluid dynamics solutions, powering next-generation
              transportation through relentless R&D and strategic collaborations across industries.
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Company